/**
 * @Description Reducer for manual commission records filter
 * @FileName manualCommissionRecordsFilter.js
 * @Author Karthick - kkarthk
 * @CreatedOn 06 Oct, 2022 04:15:36
 * @IssueID - Issue IDs
 */

import { basicManualAdjFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { mcrDetailActionTypes } from '../actions/actionTypes';

export const FILTER_REDUCER_NAME = 'ManualCommissionRecordsFilterList';

const updateFilSetStore = (state, action) => ({
  ...state,
  selectedFilter: action.data.selectedItem || null,
  systemDefaultFilter: action.data.systemDefault || null,
  userDefaultFilter: action.data.userDefault || null,
});

const updateFilterConfig = (state, action) => {
  if (action.data && action.data.systemDefault) {
    return updateFilSetStore(state, action);
  }
  if (
    (action.data && action.data.userDefault === null)
    || (action.data && action.data.userDefault)
  ) {
    return {
      ...state,
      selectedFilter: action.data.selectedItem || null,
      userDefaultFilter: action.data.userDefault,
    };
  }
  return {
    ...state,
    selectedFilter: (action.data && action.data.selectedItem) || null,
  };
};

const updateFilterOption = (state, action) => ({
  ...state,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  listColumnOrder: action.data ? action.data.detail.columnOrders : [],
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
  selectedFilter: action.data ? action.data : null,
});

const logMCRListRequest = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const formatListData = (listData) => {
  listData.data.map((item) => {
    const clone = item;
    clone.isDefaultCheck = item.wadStat === 'APP';
    return clone;
  });
  return listData;
};

const manualCommissionRecordsState1 = (state = { ...basicManualAdjFilterInitialState }, action = null) => {
  switch (action.type) {
    case mcrDetailActionTypes.UPDATE_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case mcrDetailActionTypes.REMOVE_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case mcrDetailActionTypes.UPDATE_TABLE_CONFIGURATION:
      return updateFilterOption(state, action);
    case mcrDetailActionTypes.LOG_MCR_LIST_REQUEST:
      return logMCRListRequest(state, action);
    case mcrDetailActionTypes.GET_MCR_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    default:
      return null;
  }
};
const manualCommissionRecordsState2 = (state = { ...basicManualAdjFilterInitialState,
  usrStatFlg: 0 }, action = null) => {
  switch (action.type) {
    case mcrDetailActionTypes.GET_MCR_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case mcrDetailActionTypes.GET_MCR_LIST_RESPONSE:
      return {
        ...state,
        importedJobId: action.data.importedJobId,
        listData: formatListData(action.data),
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case mcrDetailActionTypes.SET_CHCK_STAT_USR:
      return {
        ...state,
        usrStatFlg: action.data,
        loading: false,
      };
    case mcrDetailActionTypes.RESET_MCR_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case mcrDetailActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicManualAdjFilterInitialState;
    default:
      return null;
  }
};
const ManualCommissionRecordsFilterList = (state = { ...basicManualAdjFilterInitialState }, action = null) => {
  const state1 = manualCommissionRecordsState1(state, action);
  const state2 = manualCommissionRecordsState2(state, action);
  if (state1 !== null) {
    return state1;
  }
  if (state2 !== null) {
    return state2;
  }
  return state;
};

export default ManualCommissionRecordsFilterList;
